import React from 'react';
import IndexedFormRow from '../IndexedFormRow';
import CollapseContainer from "../../CollapseContainer/CollapseContainer";
import { Field } from "redux-form";
import InputField from '../InputField';
import { renderField } from '../../../utils/formUtils';
import PrivacyRow from "../PrivacyRow/PrivacyRow";
import SocialDropdown from "./SocialDropdown";
import { Translate } from "react-localize-redux";
import './styles.scss';

const SOCIAL_CHOICES = [
  'Facebook',
  'Instagram',
  'Twitter',
  'QQ',
  'Linkedin',
  'YouTube',
  'Google+',
  'Vkontakte',
  'Pinterest',
  'Reddit',
  'Flickr',
  'Skype',
  'Snapchat',
  'Sina Weibo',
];

const socialHelperUrls = {
  "Facebook": "https://knowledgebase.constantcontact.com/articles/KnowledgeBase/6069-find-the-url-for-a-facebook-profile-or-business-page?lang=en_US",
  "Instagram": "https://help.instagram.com/372819389498306",
  "Twitter": "https://www.techwalla.com/articles/how-to-find-my-twitter-url",
  "QQ": "https://chinahelp4u.com/the-difference-between-qq-id-wechat-id-and-email/",
  "Linkedin": "https://www.linkedin.com/help/linkedin/answer/49315/finding-your-linkedin-public-profile-url?lang=en",
  "YouTube": "https://www.youtube.com/watch?v=gR-RYOnNwPQ",
  "Google+": "https://goviralnow.net/how-to-find-your-google-url-and-true-local-url/",
  "Vkontakte": "http://vkuid.com/",
  "Pinterest": "https://help.pinterest.com/en/article/edit-your-profile",
  "Reddit": "https://www.reddit.com/r/help/comments/4uivdf/whats_the_link_that_redirects_to_your_reddit/",
  "Flickr": "https://www.pixsy.com/academy/flickr-id/",
  "Skype": "https://support.skype.com/en/faq/FA10858/what-s-my-skype-name?q=where+is+my+skype+link",
  "Snapchat": "https://support.snapchat.com/en-US/a/change-username",
  "Sina Weibo": "https://www.sicnotation.com/blog/weibo-guide",
};

const renderCustomSocialType = field => renderField(field, null, 'custom-social-type')

const defaultEntries = [
  {
    social_type: 'Facebook',
    name: 'https://www.facebook.com/yourname',
    privacy: 'PU',
    img_url: 'https://s3-eu-west-1.amazonaws.com/myhellohellostatic/media/users/social_media_icons/facebook-logo.png',
    order_index: 1
  },
  {
    social_type: 'Instagram',
    name: 'https://www.instagram.com/yourname',
    privacy: 'PU',
    img_url: 'https://s3-eu-west-1.amazonaws.com/myhellohellostatic/media/users/social_media_icons/instagram-logo.png',
    order_index: 2
  }
];

const SocialFormPanel = () => (
  <CollapseContainer title={<Translate id="Social" />} startCollapsed={false}>
    <IndexedFormRow
      defaultEntries={defaultEntries}
      modelArrayName="social_accounts"
      privacyRow={<PrivacyRow rowOffset={8}/>}
      showCategory={false}
      addComponent={onChange => <SocialDropdown onChange={onChange} />}
      showRemove
      dataComponent={(member, dataObj) => (
        <React.Fragment>
          <div className="row social-data-row">
            <div className="col-3 social-label text-center">
              {!SOCIAL_CHOICES.includes(dataObj.social_type) ? (
                <Field
                  name={`${member}.social_type`}
                  type="text"
                  hideLabel={true}
                  // component={field => renderField(field, null, 'custom-social-type')}
                  component={renderCustomSocialType}
                  placeholder={dataObj.placeholder}
                  label="social"
                />
              ) : (
                <span className="social-label-type">{dataObj.social_type}</span>
              )}
            </div>
            <div className="col-1 social-img-sm-container">
              <img
                src={`${dataObj.img_url}`}
                className="social-img-sm"
              />
            </div>
            <div className="col-7">
              <Field
                name={`${member}.name`}
                type="text"
                hideLabel={true}
                component={InputField}
                placeholder={dataObj.placeholder}
                label="social"
              />
            </div>
            <div className="col-1 social-img-sm-container">
              {
                SOCIAL_CHOICES.includes(dataObj.social_type) &&
                <i
                  className="fa fa-question-circle social-help-link"
                  onClick={() => window.open(socialHelperUrls[dataObj.social_type], "_blank")}
                ></i>
              }
            </div>
          </div>

        </React.Fragment>
        )}
    />
  </CollapseContainer>
);

export default SocialFormPanel;


// WEBPACK FOOTER //
// ./src/components/forms/SocialFormPanel/SocialFormPanel.jsx